import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const POPUP_CLOSED_KEY = 'popup_closed_date';

export default function PopupNotice() {
  const [isOpen, setIsOpen] = useState(false);
  const [dontShowToday, setDontShowToday] = useState(false);

  useEffect(() => {
    const closedDate = localStorage.getItem(POPUP_CLOSED_KEY);
    const today = new Date().toDateString();

    if (closedDate !== today) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    if (dontShowToday) {
      localStorage.setItem(POPUP_CLOSED_KEY, new Date().toDateString());
    }
    setIsOpen(false);
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4"
      onClick={handleOverlayClick}
    >
      <div className="relative w-full max-w-[350px] animate-in fade-in zoom-in duration-300">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute -top-3 -right-3 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-white shadow-lg transition-transform hover:scale-110"
          aria-label="닫기"
        >
          <X className="h-5 w-5 text-gray-600" />
        </button>

        {/* Popup content */}
        <div className="overflow-hidden rounded-xl bg-white shadow-2xl">
          {/* Image */}
          <div className="w-full">
            <img
              src="https://static.wixstatic.com/media/7e5c54_d70d8ddd604548d3b4cf3db479786eec~mv2.jpg"
              alt="공지사항"
              className="w-full h-auto block"
            />
          </div>

          {/* Footer with checkbox */}
          <div className="flex items-center justify-between border-t border-gray-100 bg-white px-4 py-3">
            <label className="flex cursor-pointer items-center gap-2 text-sm text-gray-600">
              <input
                type="checkbox"
                checked={dontShowToday}
                onChange={(e) => setDontShowToday(e.target.checked)}
                className="h-4 w-4 rounded border-gray-300 text-[#8B7355] focus:ring-[#8B7355]"
              />
              <span>오늘 하루 동안 보지 않기</span>
            </label>
            <button
              onClick={handleClose}
              className="text-sm font-medium text-gray-500 hover:text-gray-700"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}